import React from 'react';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { useChanges, Form } from '../../../../components/Form/Form';
import { isEmpty } from 'lodash';
import { TextField } from '../../../../components/Form/TextField/TextField';
import { t } from '../../../../locales/translate';
import { editItems } from '../../../../model/item';

interface Props {
  orderId: string;
  itemId?: string;
  controller: ModalController<{ personalIdentifier?: string | null }>;
}

export function PersonalIdentifierModal({ orderId, itemId, controller }: Props): JSX.Element {
  const [changes, , model, trackChanges] = useChanges<{
    personalIdentifier?: string | null;
  }>(controller.model);

  async function handleOnSubmit(): Promise<void> {
    if (itemId) {
      await editItems(orderId, [itemId], model);
    }
    controller.close();
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid && !isEmpty(changes),
        });
        return (
          <>
            <TextField label={t.model.ticket.ticketPersonalization} name="personalIdentifier" />
          </>
        );
      }}
    </Form>
  );
}
